module.exports = {
  fixedEncodeURIComponent (str) {
    var report = encodeURIComponent(str)
    report = report.replace(/%26/g, '-9999-')  // &
    report = report.replace(/%2B/g, '-9998-')  // +
    report = report.replace(/%2F/g, '-9997-')  // /
    report = report.replace(/%3E/g, '-9996-')  // >
    report = report.replace(/\./g, '-9995-')   // .
    report = report.replace(/%23/g, '-9994-')  // #
    report = report.replace(/%2C/g, '-9993-')  // ,
    report = report.replace(/%25/g, '-9992-')  // %
    report = report.replace(/%3A/g, '-9991-')  // %
    return report
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
    // return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
    //   return '%' + c.charCodeAt(0).toString(16)
    // })
  },
}



